import {css} from 'styled-components';

export const textOverflowStyleObj = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  'white-space': 'nowrap',
};

export const textOverflowCss = css(textOverflowStyleObj);
